/** Shared product settings — keep in sync with backend/config/appConstants.js */

export const TEST_TIME_LIMIT_MINUTES = 60;
export const TEST_TIME_LIMIT_SECONDS = TEST_TIME_LIMIT_MINUTES * 60;

/** Original (MRP) price — always shown struck-through next to the selling price. */
export const TEST_MRP_INR = 499;
/** Selling price actually charged (before any coupon). */
export const TEST_PRICE_INR = 199;
export const TEST_PRICE_PAISE = TEST_PRICE_INR * 100;

/** Support contact — single source of truth for every phone/WhatsApp link. */
export const SUPPORT_PHONE_DISPLAY = '+91 90636 87405';
export const SUPPORT_PHONE_TEL = 'tel:+919063687405';
export const SUPPORT_WHATSAPP_URL = 'https://wa.me/919063687405';
export const SUPPORT_EMAIL = 'support@careercompass.com';

export const COMPANY_NAME = 'VIJNA Academy';
export const COMPANY_ADDRESS = 'VIJNA Academy, Hyderabad, Telangana';
